exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.titlleArea[data-v-ee1f8e0a] {\n    background-color: #30BAAF;\n    border-top-right-radius: 0.2rem;\n    border-top-left-radius: 0.2rem;\n    height: 2.5rem;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n.titleText[data-v-ee1f8e0a] {\n    font-size: 1.2rem;\n}\n.closeBtn[data-v-ee1f8e0a]{\n    font-size: 2rem;\n    padding-left: 8px;\n    padding-right: 8px;\n    font-weight: bold;\n    cursor: pointer;\n}\n", ""]);

// exports
